export enum TipoAutoridad {
  AUTORIDAD_FACULTADA = 1,

  AUTORIDAD_SUPLENTE = 2,

  ENLACE_INSTITUCIONAL = 3,
}
